import SecureBootHub from "components/modules/SecureBootHub";

const SecureBootPage = () => {
  return <SecureBootHub />;
};

export default SecureBootPage;
